import React from "react";

export const Content = ({ children }) => (
  <div style={{ position: "relative" }}>{children}</div>
);
